import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { DateFormat, DestroySubscribers } from '@ftr/foundation'
import { SttRemarkWithPlayerInformation } from '../../SttRemarkWithMetadata'

@Component({
  selector: 'ftr-remark-failed',
  templateUrl: './remark-failed.component.html',
  styleUrls: ['./remark-failed.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RemarkFailedComponent extends DestroySubscribers {
  @Input() remark: SttRemarkWithPlayerInformation

  readonly dateFormats = DateFormat
}
